export const HTML2DOM = (html) => {
  const tmp = document.createElement("template");
  tmp.innerHTML = html;
  return tmp.content.firstElementChild;
};

export const classNames = (...classNames) =>
  classNames.filter(Boolean).join(" ");

  export const styles = (...styles) => styles.filter(Boolean).join(";");